import React from "react";
import { GlobalLayout } from "../../components";
import CodePlayground from "../../components/activities/code-playground";
const CodePlaygroundPage = () => {
  return (
    <GlobalLayout>
      <CodePlayground/>
    </GlobalLayout>
  );
};

export default CodePlaygroundPage;
